import React from 'react';
import { Icon } from '@iconify/react';

const WHY_REASONS = [
    {
        step: 1,
        label: 'The problem we solve',
        icon: 'mdi:clock-outline',
        title: 'Crypto never sleeps — but you should',
        description: 'Markets run 24/7. Missing a dip or spike can hurt your results. NeuraTrader watches the charts, analyzes data, and executes on your rules so you are not glued to a screen.',
    },
    {
        step: 2,
        label: 'How it works',
        icon: 'mdi:brain',
        title: 'Built on logic, not luck',
        description: 'Grid, scheduled, and algo bots follow the strategies you configure — not gut feeling. Use proven rules, order templates, and monitors to trade with discipline.',
    },
    {
        step: 3,
        label: 'What you gain',
        icon: 'mdi:chart-line',
        title: 'Less stress, more control',
        description: 'Automation removes panic from the equation. Whether you are new or experienced, you get a consistent process: set limits, enable bots, and track results from one dashboard.',
    },
    {
        step: 4,
        label: 'Why trust us',
        icon: 'mdi:rocket-launch-outline',
        title: 'Your success is our mission',
        description: 'We focus on reliable tooling — not hype. Secure API integration, transparent plan limits, and documentation that helps you set up bots the right way.',
    },
];

function WhyReasonCard({ reason }) {
    return (
        <article className="home-why-card">
            <div className="home-why-card-top">
                <span className="home-why-icon" aria-hidden="true">
                    <Icon icon={reason.icon} width={22} height={22} />
                </span>
                <div>
                    <p className="home-why-label">{reason.label}</p>
                    <h3 className="home-why-title">{reason.title}</h3>
                </div>
            </div>
            <p className="home-why-text">{reason.description}</p>
        </article>
    );
}

function WhyReasons() {
    return (
        <section className="home-section">
            <div className="home-section-header">
                <span className="home-eyebrow">Why NeuraTrader</span>
                <h2 className="home-section-title">The NeuraTrader advantage</h2>
                <p className="home-section-text">
                    Four reasons traders choose NeuraTrader — in the order that matters most.
                </p>
            </div>
            <div className="home-why-grid">
                {WHY_REASONS.map((reason) => (
                    <WhyReasonCard key={reason.step} reason={reason} />
                ))}
            </div>
        </section>
    );
}

export default WhyReasons;